import { Component, DestroyRef, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductInspectorService } from './services/product-inspector.service';
import { AuthService } from './services/auth.service';
import { HeaderComponent } from './header/header.component';
import { RouterOutlet } from '@angular/router';
import { OverlayLegendComponent } from './components/planogram/overlay-legend/overlay-legend.component';
import { FooterComponent } from './footer/footer.component';
import { ToastsComponent } from './toasts/toasts.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        HeaderComponent,
        RouterOutlet,
        OverlayLegendComponent,
        FooterComponent,
        ToastsComponent,
    ],
})
export class AppComponent implements OnInit {
  title = 'OnPlan.Frontend';
  authorized = false;

  private destroyRef = inject(DestroyRef);

  constructor(
    public productInspectorService: ProductInspectorService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.authorized.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(authorized => {
      this.authorized = authorized;
    });
  }
}
